// extracted by css-extract-rspack-plugin
export default {"content":"content-fYVYDY text-body-sm"};